import React, { useContext, useEffect, useState } from "react";
import './Snackbar.scss';
import SnackbarContext from '../../../provider/Context/SnackbarContext';

export interface ISnackbarProps {    
    cssClass?: string | "";   
}

const Snackbar: React.FC<ISnackbarProps> = (props) => {
  
    const [message, setMessage] = useState<string>("");

    const {displayMsg, msg, onClose } = useContext(SnackbarContext)
   
    const closeSnackbar = ()=>{
        onClose();
    }
    useEffect(()=>{
      setMessage(msg)
    },[])    

    return (
        <div id="snack-bar" className={`snackbar-container ${props.cssClass}`}>
            <div className="snakbar-text-container">
                <img className="snackbar-error-icon"></img>  <div className="snackbar-text">{message} </div><div className="snackbar-close-btn"
                    onClick={(e) => {closeSnackbar()}}>&times;</div>
            </div>
        </div>
    )
}

export default Snackbar;